/**
 * Trending Name Search Redirect Middleware
 * @param route
 * @param redirect
 */
export default function({ route, redirect, $config: { website } }) {
  const { params } = route;
  const currentYear = new Date().getFullYear();
  let minYear = 2018;
  let redirectUrl;

  switch (website) {
    case 'template':
    case 'information':
      redirectUrl = '/popular-names/';
      minYear = 1999;
      break;
    case 'checkpeople':
      redirectUrl = '/recent-name-searches';
      minYear = 2010;
      break;
    case 'unmask':
      redirectUrl = '/trending-name-search/';
      minYear = 2012;
      break;
    default:
      redirectUrl = '/trending-name-search/';
      break;
  }

  if (
    isNaN(params.year) ||
    params.year > currentYear ||
    params.year < minYear
  ) {
    redirect(redirectUrl);
  }
}
